export function getBundledDefaultAvatarUrl(baseAssetsPath) {
  const baseUrl = baseAssetsPath || window.location.href;
  return new URL("assets/models/DefaultAvatar.glb", baseUrl).href;
}
